import { message } from "antd";
import { EmailTemplateFormCard } from "./components/EmailTemplateForm";
import { useMutation, useQuery } from "@tanstack/react-query";
import { EmailTemplate } from "@rumble-it/common-lib/types/models/EmailTemplate.interface";
import {
  fetchEmailTemplateById,
  updateEmailTemplateById,
} from "../../../lib/api/resources/emailTemplates";
import { useNavigate, useParams } from "react-router-dom";

export const EmailTemplateEdit = () => {
  const { id } = useParams();

  if (!id) return null;
  const navigate = useNavigate();

  const emailTemplateQuery = useQuery({
    queryKey: ["emailTemplate", id],
    queryFn: () => fetchEmailTemplateById(id),
  });

  const updateEmailTemplateMutation = useMutation({
    mutationFn: (data: EmailTemplate) => updateEmailTemplateById(id, data),
    onSuccess: () => {
      navigate(`/email-templates/${id}`);
      message.success("Email Template succesvol bijgewerkt");
    },
    onError: () =>
      message.error(
        "Er is een fout opgetreden bij het bijwerken van de Email Template",
      ),
  });

  return (
    <div>
      <EmailTemplateFormCard
        loading={emailTemplateQuery.isLoading}
        initialValues={emailTemplateQuery.data}
        mutation={updateEmailTemplateMutation}
        title="Email Template Bijwerken"
        buttonText="Bijwerken"
      />
    </div>
  );
};
